import { useToast } from '@group-link-one/gl-components';
import { SPToast } from '@group-link-one/gl-ui/sonarprint';
import type { JSX } from 'react';

import { useCreateAllRoutes } from './hooks/useCreateAllRoutes';
import { useShowFallbackPage } from '@/Templates/FallBack/hooks/useShowFallBackPage';

export const Routes = (): JSX.Element => {
  const { showPage } = useShowFallbackPage();
  const { toasts } = useToast();

  // Render routes (must be called before any conditional returns)
  const routes = useCreateAllRoutes();

  // Check maintenance/instability mode
  const fallbackPage = showPage();
  if (fallbackPage) return fallbackPage;

  return (
    <>
      {routes}

      {toasts.map(toast => (
        <SPToast key={toast.id} {...toast} />
      ))}
    </>
  );
};
